import { createContext, useState } from "react";

import {
  getAirbnbAccounts,
  disconnectAirbnbAccount,
} from "../services/airbnb.service";

export const AirbnbContext = createContext();
export const AirbnbProvider = ({ children }) => {
  const [accounts, setAccounts] = useState([]);

  let airbnbContext = {
    accounts,

    getAccounts: async () => {
      let resp = await getAirbnbAccounts();
      if (!!resp.error) {
        console.log("Error getting accounts", resp.error);
        setAccounts([]);
      }

      setAccounts(resp.data?.accounts || []);
    },

    disconnectAccount: async (account_id) => {
      let resp = await disconnectAirbnbAccount(account_id);
      if (!!resp.error) {
        console.log("Error disconnecting account:", resp.error);
        return;
      }

      console.log(resp.data);
      setAccounts(resp.data?.accounts || []);
    },
  };

  return (
    <AirbnbContext.Provider value={airbnbContext}>
      {children}
    </AirbnbContext.Provider>
  );
};
